'use client';

import { createContext, useContext, type ReactNode } from 'react';

export type DefaultSelectionContextValue = {
  /** SSR 魔方 `lens_process_default_selection`：是否启用配镜默认勾选等行为 */
  hasDefaultSelection: boolean;
  /**
   * 是否允许更新「上次选中」localStorage（`mergePrevLensSelection`）。
   * 购物车改配镜、积分兑换等入口应为 false，避免污染用户常规记忆。
   */
  canModifyPrevSelection: boolean;
};

const defaultSelectionContextValue: DefaultSelectionContextValue = {
  hasDefaultSelection: false,
  canModifyPrevSelection: true,
};

export const DefaultSelectionContext = createContext<DefaultSelectionContextValue>(
  defaultSelectionContextValue,
);

export function DefaultSelectionProvider({
  hasDefaultSelection,
  canModifyPrevSelection = true,
  children,
}: {
  hasDefaultSelection: boolean;
  canModifyPrevSelection?: boolean;
  children: ReactNode;
}) {
  const value: DefaultSelectionContextValue = {
    hasDefaultSelection,
    canModifyPrevSelection,
  };
  return (
    <DefaultSelectionContext.Provider value={value}>{children}</DefaultSelectionContext.Provider>
  );
}

/** 配镜默认勾选相关上下文；按需解构字段即可，无需多个 useXxx 包装 */
export function useDefaultSelection() {
  return useContext(DefaultSelectionContext);
}
